import moment from 'moment';
import size from 'lodash';

const getFormattedDate = (date, format = 'MM/DD/YYYY') => {
  if (size(date)) return moment(date).format(format);
  return '';
};

export default getFormattedDate;
